async function mapEngine() {
  const container = document.getElementById("bbMapAllItems");
  const loader = document.getElementById("bbLoader");

  if (!container) {
    return;
  }

  const response = await fetch(
    "https://coronarchiv.geschichte.uni-hamburg.de/projector/api/mapping_markers?per_page=99999"
  );
  const rawData = await response.json();

  const data = rawData.map((value) => {
    return {
      title: value["o-module-mapping:label"],
      lat: value["o-module-mapping:lat"],
      lng: value["o-module-mapping:lng"],
      id: value["o:item"]["o:id"],
    };
  });

  let map = L.map("bbMapAllItems", { tap: false }).setView([20, 0], 2);

  L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  }).addTo(map);

  let mcg = L.markerClusterGroup({
    chunkedLoading: true,
    spiderfyOnMaxZoom: false,
  });

  data.forEach((item) => {
    let lat = item.lat;
    let lgn = item.lng;
    let title = item.title;
    let id = item.id;

    let marker = L.marker(new L.LatLng(lat, lgn), { title: title });

    marker.bindPopup(
      `<div id="${id}"><a href="" target="_blank" rel="noopener noreferrer"><span class="bb-map-popup-title"></span><img src=""></a></div>`
    );

    mcg.addLayer(marker);
  });
  map.addLayer(mcg);
  loader.style.display = "none";

  map.on("popupopen", async function (event) {
    let popup = event.popup._contentNode.childNodes[0];
    let link = popup.querySelector("a");
    let title = popup.querySelector("span");
    let image = popup.querySelector("img");

    let id = event.popup._contentNode.childNodes[0].id;

    let response = await fetch("https://coronarchiv.geschichte.uni-hamburg.de/projector/api/items/" + id);
    let data = await response.json();

    title.textContent = data["o:title"];
    link.href = `/item/?id=${id}`;

    let thumbnail = data.thumbnail_display_urls.square;

    if (!thumbnail) {
      return;
    }

    if (thumbnail.includes("https://coronarchiv.geschichte.uni-hamburg.de")) {
      image.src = thumbnail;
    } else {
      image.src = "https://coronarchiv.geschichte.uni-hamburg.de" + thumbnail;
    }
  });
}

document.addEventListener("DOMContentLoaded", mapEngine);
